<template>
  <div style="
        display: inline-flex;
        color:#c00000;
        border-radius: 14px;
        margin: 10px 0 0 0;
        display: flex;
        justify-content: center;
        align-items: center; 
        font-size: 18px;
        font-weight: bold;
      ">
    <div >Results for the 2018-2026 Time-window will be Provided once the 2026 Data is Fully Available
    </div>

  </div>
</template>

<script>


export default {


  data() {
    return {

    };
  },




};
</script>

<style scoped></style>